<template>
  <div class="max-w-3xl mx-auto">
    <div class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
      <label class="text-base font-medium text-gray-900"
        >Manual Message Sending Preference</label
      >
      <p class="text-sm leading-5 text-gray-500">
        You can either choose to send manual messages using whatsapp web or
        desktop app
      </p>
      <fieldset class="mt-4">
        <legend class="sr-only">Method</legend>
        <div class="space-y-4">
          <div
            class="flex items-center"
            v-for="(option, index) of options"
            :key="index"
          >
            <input
              :id="`pref_${index}`"
              name="notification-method"
              v-model="sendMessagesUsingDesktopApp"
              :value="option.value"
              type="radio"
              class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
              @input="updatePreference(option.value)"
            />
            <label
              :for="`pref_${index}`"
              class="ml-3 block text-sm font-medium text-gray-700"
            >
              {{ option.label }}
            </label>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sendMessagesUsingDesktopApp: false,
      options: [
        {
          label: "Whatsapp Web",
          value: false
        },
        {
          label: "Whatsapp Desktop App",
          value: true
        }
      ]
    };
  },
  created() {
    const store = this.$store.getters.getStore;
    console.log("hello", store);
    this.sendMessagesUsingDesktopApp = store.sendMessagesUsingDesktopApp;
  },
  methods: {
    updatePreference(value) {
      this.$store.dispatch("updatePreference", {
        requestParams: {
          sendMessagesUsingDesktopApp: value
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
